module.exports = __webpack_public_path__ + "img/icon-gift.63c93a5.webp";